import { z } from "zod";

import i18next from "../../../../../../i18n";
const NON_CLIENT_MIN_DUE_DATE_OFFSET_DAYS = 6;

export const createInvoiceSchema = (userRole: string | undefined) => {
    const invalidDate: string = i18next.t("errorMessages:invoiceForm.invalidDate");
    const futureDate: string = i18next.t("errorMessages:invoiceForm.futureDate");
    const invalidDueDate: string = i18next.t("errorMessages:invoiceForm.invalidDueDate");
    const invoiceReferenceMin: string = i18next.t("errorMessages:invoiceForm.invoiceReferenceMin");
    const invalidDueDateClient: string = i18next.t("errorMessages:invoiceForm.invalidDueDateClient");
    const totalConfirmation: string = i18next.t("errorMessages:invoiceForm.totalConfirmation");
    const addressConfirmation: string = i18next.t("errorMessages:invoiceForm.addressConfirmation");
    const personalSensitiveConfirmation: string = i18next.t("errorMessages:invoiceForm.personalSensitiveConfirmation");
    const missingClaimReference: string = i18next.t("errorMessages:invoiceForm.missingClaimReference");

    const pastDate: string = i18next.t("errorMessages:invoiceForm.pastDate");

    return z.object({
        invoiceDate: z.coerce
            .date({ error: invalidDate })
            .refine(val => val < new Date(), { message: futureDate })
            .refine(
                val => {
                    const today = new Date();
                    const oneYearAgo = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
                    return val >= oneYearAgo;
                },
                { message: pastDate }
            ),
        invoiceDueDate: z.coerce.date({ error: invalidDate }).refine(
            val => {
                const today = new Date();
                const dueDate = new Date(val);
                const validDueDate = new Date(
                    today.getFullYear(),
                    today.getMonth(),
                    today.getDate() + NON_CLIENT_MIN_DUE_DATE_OFFSET_DAYS
                );
                if (userRole === "Client") {
                    return dueDate.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0);
                }
                return dueDate >= validDueDate;
            },
            { message: userRole === "Client" ? invalidDueDateClient : invalidDueDate }
        ),
        invoiceNumber: z.nullable(z.string({ error: invoiceReferenceMin }).min(1, invoiceReferenceMin)),
        claimRef: z.string({ error: missingClaimReference }).min(1, missingClaimReference),
        subClaimsRef: z.string({ error: missingClaimReference }).min(1, missingClaimReference),
        totalConfirmation: z.coerce.boolean().refine(val => val, {
            message: totalConfirmation
        }),
        addressConfirmation: z.coerce.boolean().refine(val => val, {
            message: addressConfirmation
        }),
        personalSensitiveConfirmation: z.coerce.boolean().refine(val => val, {
            message: personalSensitiveConfirmation
        }),
        invoiceAttachment: z.object({
            file: z.any().optional(),
            docId: z.string().optional(),
            filename: z.string().optional(),
            fileSize: z.number().optional(),
            fileExtension: z.string().optional(),
            isUploading: z.boolean().optional(),
            isUploaded: z.boolean().optional(),
            uploadFailed: z.boolean().optional()
        }),
        branchCompanyCrmId: z.string().optional(),
        submittedOnBehalfOfCrmId: z.string().optional(),
        submittedOnBehalfOfCompanyName: z.string().optional()
    });
};
